import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import api, { GenericError } from "../api"
import { ConsolidationRequest } from "../api/consolidation.api"
import { EconomyconsolMasterLabelRequest } from "./../api/consolidation.api"

export interface EconomyConsolsListState {
    economyconsols: Record<string, any>[]
    countriesList: Record<string, any>[]
    selectedCountry?: string
    loading: boolean
    error?: GenericError
    success?: boolean
    label?: string
}

const initialState: EconomyConsolsListState = {
    economyconsols: [],
    countriesList: [],
    selectedCountry: "",
    loading: false
}

export const loadCountriesList = createAsyncThunk("economyconsols/countries-list", async (thunkAPI) => {
    try {
        return await api.consolidation.countriesList()
    } catch (error: any) {
        console.log(error)
        return error.message
    }
})

export const loadEconomyConsols = createAsyncThunk(
    "economyconsols/list",
    async ({ country }: { country?: string }, thunkAPI) => {
        try {
            return await api.consolidation.economyconsolsList({ country })
        } catch (error: any) {
            console.log(error)
            return error.message
        }
    }
)

export const multiBoxEconomyConsol = createAsyncThunk(
    "economyconsols/mult-box-consolidation",
    async (consolidationData: ConsolidationRequest, thunkAPI) => {
        try {
            return await api.consolidation.multiBoxConsolidation(consolidationData)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const generateMasterLabel = createAsyncThunk(
    "economyconsols/master-label",
    async (economyconsolMasterLabelData: EconomyconsolMasterLabelRequest, thunkAPI) => {
        try {
            return await api.consolidation.economyconsolsMaterLabel(economyconsolMasterLabelData)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const economyconsolsSlice = createSlice({
    name: "economyconsols",
    initialState,

    reducers: {
        clearError: (state: EconomyConsolsListState) => {
            state.error = undefined
        },
        resetSuccess: (state: EconomyConsolsListState) => {
            state.success = undefined
        },
        setSelectedCountry: (state: EconomyConsolsListState, action: PayloadAction<any>) => {
            state.selectedCountry = action.payload || "AE"
        },
        resetLabel: (state: EconomyConsolsListState) => {
            state.label = undefined
        }
    },

    extraReducers: {
        [loadCountriesList.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadCountriesList.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [loadCountriesList.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.countriesList = action.payload?.data?.payload || []
        },

        [loadEconomyConsols.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadEconomyConsols.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [loadEconomyConsols.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.economyconsols = action.payload?.data?.payload || []
        },

        [generateMasterLabel.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [generateMasterLabel.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [generateMasterLabel.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            state.label = action.payload?.data?.payload?.label?.label_path || ""
        }
    }
})

export const { clearError, setSelectedCountry, resetSuccess, resetLabel } = economyconsolsSlice.actions

export default economyconsolsSlice.reducer
